import { createUseStyles } from 'react-jss';

const styles = {
  actionGroupItem: {
    margin: '0.2rem'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'ClarifyQuery'
});
